import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Action } from "../../components/ActionBar/ActionBar";
import { Header } from "../../components/Header/Header";
import { Title } from "../../components/Title/Title";
import { useAdminUrlInfo } from "../../hooks/useAdminUrlInfo";
import { AdminViewParams, ADMIN_VIEW_PATH } from "../../routes";
import { UserScopeEnum } from "../../schema";
import { buildUrl } from "../../services/buildUrl";
import { InformativeContentDetailsProps } from "./InformativeContentDetailsView";

export const InformativeContentDetailsHeader: React.FC<InformativeContentDetailsProps> = ({ informativeContent }) => {
  const navigate = useNavigate();
  const { modifier } = useAdminUrlInfo();

  // detect edit mode
  const isEditMode = modifier === "edit";
  // header buttons configuration
  const actions: Action[] = useMemo(
    () => [
      isEditMode
        ? {
            label: "Details",
            onClick: () =>
              navigate({
                pathname: buildUrl<AdminViewParams>(ADMIN_VIEW_PATH, {
                  menu: "clarity-score",
                  page: "informative-content",
                  id: informativeContent.id,
                }),
              }),
          }
        : {
            label: "Edit",
            authorizedScopes: [
              UserScopeEnum.SUPERADMIN,
              UserScopeEnum.CLARITY_TEST_INFORMATIVE_CONTENT,
              UserScopeEnum.CLARITY_TEST_UPDATE_INFORMATIVE_CONTENT,
            ],
            onClick: () =>
              navigate({
                pathname: buildUrl<AdminViewParams>(ADMIN_VIEW_PATH, {
                  menu: "clarity-score",
                  page: "informative-content",
                  id: informativeContent.id,
                  modifier: "edit",
                }),
              }),
          },
    ],
    [isEditMode, navigate, informativeContent.id],
  );
  // header navigation configuration
  const navigation: Action[] = useMemo(() => [], []);
  return (
    <Header actions={actions} navigation={navigation}>
      <Title>{informativeContent.title.EN}</Title>
    </Header>
  );
};
